var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login content"},[_c('header'),_c('div',{staticClass:"login-wrapper"},[_c('div',{staticClass:"login-content pb-2"},[_c('p',[_vm._v("Logging out...")])])])])
}]

export { render, staticRenderFns }